export class Entity {
    constructor(schema, attributes, attributesContainerSchema, attributesContainerSchemaLocation) {
        this.schema = schema;
        this.attributes = attributes;
        this.attributesContainerSchema = attributesContainerSchema;
        this.attributesContainerSchemaLocation = attributesContainerSchemaLocation;
    }
    attributeNamed(attributeName) {
        for (const attribute of this.attributes) {
            if (attribute.name === attributeName) {
                return attribute;
            }
        }
        return undefined;
    }
}
